import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import Layout from 'gatsby-theme-core/src/layout/layout';
import Container from 'gatsby-theme-core/src/components/container';
import Content from 'gatsby-theme-core/src/components/content';
import SocialWidget from 'gatsby-theme-pdv/src/components/social-widget';

const regexRemoveHtml = /(<([^>]+)>)/ig;

export const query = graphql`
  query PodcastPostByPath($path: String!) {
    podcast: wpPodcast(uri: { eq: $path } ) {
      content
      title
      uri
      excerpt
      featuredImage {
        node {
          gatsbyImage(
            layout: FIXED
            width: 380
            quality: 80
          )
        }
      }
    }
  }
`;

const PodcastTemplate = ({ data }) => {
  const {
    content,
    title,
    uri,
    excerpt,
    featuredImage,
  } = data.podcast;

  const head = {
    headPageTitle: title,
    headTitle: title,
    headSlug: uri,
    headMetaDescription: excerpt.replace(regexRemoveHtml, '').replace('[&hellip;]', '...'),
    headImage: featuredImage?.node,
  };

  return (
    <Layout {...head}>
      <PostWrapper>
        <Container small>
          <Title dangerouslySetInnerHTML={{ __html: title }} />
          <Content $content={content} />
        </Container>
      </PostWrapper>
      <SocialWidget />
    </Layout>
  );
};

export default PodcastTemplate;

const PostWrapper = styled.article`
  background-color: ${(props) => props.theme.gray1};
  padding: 60px 0;
`;

const Title = styled.h1`
  margin: 0;
  padding-bottom: 40px;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 2rem;
  line-height: 2.5rem;
  text-transform: uppercase;
`;
